import dateLocale from 'date-fns/locale/en-US';

import { createBaseStringSet } from './createBaseStringSet';

const StringSetEn = createBaseStringSet({ dateLocale });

export default StringSetEn;
